module.exports = __webpack_public_path__ + "img/JSD400.0f330a56.png";